import { ActionsInterface } from "context/initialState/Encounter";
import { ICRACK_COOKIE_TOKEN } from "./appConstants";

const salt =
  "fK4.,ErrsTO3Pasdf.?4FSapkd03H5,2EfD?0aleiPOLE8<ffdQK?@b,xjTbns4*7vkjhVCD3458Oplmnb?0&jg#fcloiUBkhdsD7*(*&^mvcjHV?0&jg#fcloieiPOLE8<ffdQKdf.?4FE8<ffdQK?@b,xjTbns4*7vkjhVCD3458Oplmnb?0&jg#fclokjhVCD3458Oplmn^mvcjHV?0&jg#fcloieiPOLE8<fEfD?0aleiPOLE8458Oplmn^mvcb?0&jg#f#fcloieiPOLE8<ffdQKdf.?4FE8<ff58OplmnbhdObXu8@ZF5?im4Kwc3QSnDdZJCf1yVfJeh<H.IilOCNcPb1fihI#fK4.,ErrsTO3Pasdf.?4FSapkd03H5,2EfD?0aleiPOLE8<ffdQK?@b,xjTbns4*7vkjhVCD3458Oplmnb?0&jg#fcloiUBkhdsD7*(*&^mvcjHV?0&jg#fcloieiPOLE8<ffdQKdf.?4FE8<ffdQK?@b,xjTbns4*7vkjhVCD3458Oplmnb?0&jg#fclokjhVCD3458Oplmn^mvcjHV?0&jg#fcloieiPOLE8<fEfD?0aleiPOLE8458Oplmn^mvcb?0&jg#f#fcloieiPOLE8<ffdQKdf.?4FE8<ff58OplmnbhdObXu8@ZF5?im4Kwc3QSnDdZJCf1yVfJeh<H.IilOCNcPb1fihI#fK4.,ErrsTO3Pasdf.?4FSapkd03H5,2EfD?0aleiPOLE8<ffdQK?@b,xjTbns4*7vkjhVCD3458Oplmnb?0&jg#fcloiUBkhdsD7*(*&^mvcjHV?0&jg#fcloieiPOLE8<ffdQKdf.?4FE8<ffdQK?@b,xjTbns4*7vkjhVCD3458Oplmnb?0&jg#fclokjhVCD3458Oplmn^mvcjHV?0&jg#fcloieiPOLE8<fEfD?0aleiPOLE8458Oplmn^mvcb?0&jg#f#fcloieiPOLE8<ffdQKdf.?4FE8<ff58OplmnbhdObXu8@ZF5?im4Kwc3QSnDdZJCf1yVfJeh<H.IilOCNcPb1fihI#fK4.,ErrsTO3Pasdf.?4FSapkd03H5,2EfD?0aleiPOLE8<ffdQK?@b,xjTbns4*7vkjhVCD3458Oplmnb?0&jg#fcloiUBkhdsD7*(*&^mvcjHV?0&jg#fcloieiPOLE8<ffdQKdf.?4FE8<ffdQK?@b,xjTbns4*7vkjhVCD3458Oplmnb?0&jg#fclokjhVCD3458Oplmn^mvcjHV?0&jg#fcloieiPOLE8<fEfD?0aleiPOLE8458Oplmn^mvcb?0&jg#f#fcloieiPOLE8<ffdQKdf.?4FE8<ff58OplmnbhdObXu8@ZF5?im4Kwc3QSnDdZJCf1yVfJeh<H.IilOCNcPb1fihI#";

const encrypt = (value: string) => {
  let divide = [];
  let i = 0;
  let final = [];
  for (let l = 0; l < value.length; l++) {
    final.push(value[l]);
    final.push(salt[l]);
  }
  while (i < 1) {
    divide.push(final.join("").slice(0, final.length / 2));
    divide.push(final.join("").slice(final.length / 2, final.length));
    final = [];
    for (let k = 0; k < divide[0].length; k++) {
      final.push(divide[0][k]);
      final.push(divide[1][k]);
    }
    i++;
  }
  return final.reverse().join("");
};

const decrypt = (value: string) => {
  let i = 0;
  let final = [];
  let temp = value.split("").reverse();
  while (i < 1) {
    let arr1 = [];
    let arr2 = [];
    for (let l = 0; l < temp.length; l++) {
      arr1.push(temp[l]);
      arr2.push(temp[l + 1]);
      l++;
    }
    temp = arr1.concat(arr2);
    i++;
  }
  for (let r = 0; r < temp.length; r++) {
    final.push(temp[r]);
    r++;
  }
  return final.join("");
};

const crackCookieToken = (
  type: "coordinator" | "provider" | ICRACK_COOKIE_TOKEN
) => {
  const decodedCookie = decodeURIComponent(document.cookie);
  let token = "";
  let coordinatorCookie = "life365_session=0";
  let providerCookie = "life365_provider=0";
  decodedCookie.split("; ").map((cookie) => {
    if (cookie.split("=")[0] === "life365_session") {
      coordinatorCookie = cookie;
    } else if (cookie.split("=")[0] === "life365_provider") {
      providerCookie = cookie;
    }
  });

  switch (type) {
    case "coordinator":
      token = JSON.parse(decrypt(coordinatorCookie.split("=")[1])).token;
      break;
    case "provider":
      token = JSON.parse(decrypt(providerCookie.split("=")[1])).token;
      break;
    default:
      break;
  }
  return token;
};

const crackCookieUsername = (origin: string) => {
  const decodedCookie = decodeURIComponent(document.cookie);
  let name = "None None";
  let coordinatorCookie = "";
  let providerCookie = "";
  if (decodedCookie) {
    decodedCookie.split("; ").map((cookie) => {
      let chip = decrypt(cookie.split("=")[1]);
      if (cookie.split("=")[0] === "life365_session") {
        coordinatorCookie = chip;
      } else if (cookie.split("=")[0] === "life365_provider") {
        providerCookie = chip;
      }
    });
  }

  if (origin === "provider") {
    if (providerCookie.length > 1) {
      name = JSON.parse(providerCookie).username;
    }
  } else {
    if (coordinatorCookie.length > 1) {
      name = JSON.parse(coordinatorCookie).username;
    }
  }
  return name;
};

const crackCookieUserId = (origin: string) => {
  const decodedCookie = decodeURIComponent(document.cookie);
  let id = "None";
  let coordinatorCookie = "";
  let providerCookie = "";
  if (decodedCookie) {
    decodedCookie.split("; ").map((cookie) => {
      let chip = decrypt(cookie.split("=")[1]);
      if (cookie.split("=")[0] === "life365_session") {
        coordinatorCookie = chip;
      } else if (cookie.split("=")[0] === "life365_provider") {
        providerCookie = chip;
      }
    });
  }
  if (origin === "provider") {
    if (providerCookie.length > 1) {
      id = JSON.parse(providerCookie).id;
    }
  } else {
    if (coordinatorCookie.length > 1) {
      id = JSON.parse(coordinatorCookie).id;
    }
  }
  return id;
};

const crackCookieUserOrg = (origin: string) => {
  const decodedCookie = decodeURIComponent(document.cookie);
  let org = "None";
  let coordinatorCookie = "";
  let providerCookie = "";
  if (decodedCookie) {
    decodedCookie.split("; ").map((cookie) => {
      let chip = decrypt(cookie.split("=")[1]);
      if (cookie.split("=")[0] === "life365_session") {
        coordinatorCookie = chip;
      } else if (cookie.split("=")[0] === "life365_provider") {
        providerCookie = chip;
      }
    });
  }
  if (origin === "provider") {
    if (providerCookie.length > 1) {
      org = JSON.parse(providerCookie).org;
    }
  } else {
    if (coordinatorCookie.length > 1) {
      org = JSON.parse(coordinatorCookie).org;
    }
  }
  return org;
};
const initiateSessionEncounter = (id: string, name: string) => {
  const newEncounter = {
    coordinatorId: crackCookieUserId("coordinator"),
    coordinatorName: crackCookieUsername("coordinator"),
    memberId: id,
    memberName: name,
    duration: 1,
    escalatedDuration: 1,
    actions: []
  };
  return window.sessionStorage.setItem(
    "encounter",
    encrypt(JSON.stringify(newEncounter))
  );
};
const updateSessionEncounter = (
  sessionEncounter: string,
  newAction: ActionsInterface,
  encounterDuration: string
) => {
  if (!sessionEncounter) return;
  let oldEncounter;
  try {
    const decrypted = decrypt(sessionEncounter);
    if (!decrypted) return;
    oldEncounter = JSON.parse(decrypted);
  } catch (err) {
    console.error("updateSessionEncounter: bad encounter blob", err);
    return;
  }
  if (!oldEncounter || !oldEncounter.actions) return;
  const newEncounter = {
    coordinatorId: crackCookieUserId("coordinator"),
    coordinatorName: crackCookieUsername("coordinator"),
    memberId: oldEncounter.memberId,
    memberName: oldEncounter.memberName,
    duration: encounterDuration,
    escalatedDuration: 1,
    actions: oldEncounter.actions.concat(newAction)
  };
  return window.sessionStorage.setItem(
    "encounter",
    encrypt(JSON.stringify(newEncounter))
  );
};

const scheduleLogout = () => {
  const decodedCookie = decodeURIComponent(document.cookie)
      .split("; ")
      .find(currCookie => currCookie.startsWith("life365_session="));

    if (!decodedCookie) return;

    const session = JSON.parse(decrypt(decodedCookie.split("=")[1]));
    const expiresAt = new Date(session.expires).getTime();
    const timeLeft = expiresAt - Date.now();

    if (timeLeft <= 0) {
      handleLogout();
      return;
    }

    if (window.logoutTimer) clearTimeout(window.logoutTimer);

    window.logoutTimer = setTimeout(() => {
      alert("Session expired. Redirecting to login.");
      handleLogout();
    }, timeLeft);
};

const handleLogout = () => {
  const isProvider = window.location.pathname.split("/")[1] === "provider";
  if (isProvider) {
    document.cookie =
      "life365_provider" +
      "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
  document.cookie =
    "life365_session" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  window.location.pathname = "/";
};

export default {
  encrypt,
  decrypt,
  crackCookieToken,
  crackCookieUsername,
  crackCookieUserId,
  updateSessionEncounter,
  initiateSessionEncounter,
  crackCookieUserOrg,
  scheduleLogout,
};
